import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { UserService } from '../user/user.service';
import {TrialService} from '../trial/trial.service';

@Injectable()
export class TrialAuthGuardService implements CanActivate {

    constructor(private userService: UserService, private router: Router, private trialService: TrialService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.userService.isLoggedIn() || (this.userService.isLoggedIn() && this.trialService.trialMode && this.trialService.max === 0)) {
            return true;
        }

        // Navigate to the login page
        this.router.navigate(['']);
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/router/trial-auth-guard.service.ts